import { useCallback, useContext } from 'react'

import { FrameBuilderSelectionContext } from '@frame-builder/contexts/selection-context'
import { FrameBuilderStringsContext } from '@frame-builder/contexts/strings-context'
import { FrameBuilderValidationContext } from '@frame-builder/contexts/validation-context'
import { type StepPreviewProps } from '@frame-builder/lib/steps'

import ConfigurationStepPreview from './configuration-step-preview'

const ArtworkImageStepPreview = ({
  stepNumber,
  openStep,
  onToggleStep,
}: StepPreviewProps) => {
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)
  const { committedStateSelectionMessages } = useContext(
    FrameBuilderSelectionContext,
  )
  const { stepPreviewAnimation } = useContext(FrameBuilderValidationContext)

  const handleClick = useCallback(() => {
    const isStepOpen = openStep === 'artworkImage'
    onToggleStep('artworkImage', !isStepOpen)
  }, [onToggleStep, openStep])

  return (
    <ConfigurationStepPreview
      title={frameBuilderStrings.artworkPreviewStepTitle}
      value={committedStateSelectionMessages?.artworkImage}
      placeholder={frameBuilderStrings.artworkPreviewPlaceholder}
      opacity={stepPreviewAnimation.artworkImageOpacity}
      stepNumber={stepNumber}
      onClick={handleClick}
      className="grow-0 shrink-0"
      valueClassName="break-all"
    />
  )
}

export default ArtworkImageStepPreview
